var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ul",
    {
      staticClass: "d-flex flex-column gr-3 text-body-1 text-secondary--text",
      attrs: { "data-qa": "brief_details" },
    },
    [
      _c("li", [
        _vm._v(
          "\n    " +
            _vm._s(
              _setup.t(
                "Получайте процент от потраченной суммы в виде бонусов",
                _setup.options
              )
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "li",
        {
          attrs: {
            "data-qa": "brief_details_max_payment_percent",
            "data-qa-percent": _vm.maxPaymentPercent,
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _setup.t(
                  "Оплачивайте бонусами до {maxPaymentPercent}% стоимости услуг клиники, 1 бонус = 1 {currencySymbol}",
                  _setup.options
                )
              ) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n    " +
            _vm._s(
              _setup.t(
                "Отслеживайте бонусы в приложении МедТочка после оформления карты лояльности",
                _setup.options
              )
            ) +
            "\n  "
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }